export const account = {
  overview: {
    navigation: {
      label: "Profil Navigation",
      profile: "Mein Profil",
      bookings: "Meine Standfläche",
      service: "Meine Bestellungen",
      support: "Mein Support",
      logout: "Abmelden",
    },
    breadcrumbs: {
      home: "Home",
      account: "Mein Account",
      profile: "Mein Profil",
      bookings: "Meine Standfläche",
      service: "Mein Service",
      support: "Mein Support",
      button: "Zurück zu Home",
      shop: "Store",
    },
    profile: {
      welcome: "Hallo",
      headers: {
        profile: "Persönliche Daten",
        contacts: "Meine Kontakte",
        company: "Firmendaten",
        varified: "verifiziert",
      },
      buttons: {
        changePassword: "Passwort ändern",
        editProfile: "Profil bearbeiten",
        addContact: "Neuen Kontakt hinzufügen",
        manageContacts: "Kontakte verwalten",
      },
      profile: {
        salutation: "Anrede",
        firstName: "Vorname",
        name: "Name",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        language: "Korrespondenzsprache",
      },
      contacts: {
        info1:
          "Im Bestellprozess werden Sie bei verschiedenen Bestellungen (z.B. Ticketbestellung, Zulieferungen an den Stand usw.) nach einem Ansprechpartner gefragt.",
        info2:
          "Hier können Sie die Kontaktdaten der Ansprechpartner vorbelegen, um sie im Bestellprozess einfach auswählen zu können.",
        info3:
          "Berechtigungen, bspw. für Ihren Messebauer, können Sie unter „Meine Bestellungen“ tätigen.",
        form: {
          title: "Kontakt hinzufügen",
          webshopContacts: {
            fields: {
              salutation: "Anrede",
              firstName: "Vorname",
              lastName: "Nachname",
              email: "E-Mail",
              phone: "Telefon",
              country: "Land",
              company: "Firma",
              language: "Korrespondenzsprache",
            },
          },
          unsavedChanges: "Ungespeicherte Änderungen",
        },
        manage: {
          title: "Kontakte verwalten",
          noData: "Es sind keine Kontakte vorhanden.",
          table: {
            name: {
              label: "Anrede", // quick fix for order
            },
            fullName: {
              label: "Name",
            },
            country: {
              label: "Land",
            },
            company: {
              label: "Firma",
            },
            phone: {
              label: "Telefon",
            },
            email: {
              label: "E-Mail",
            },
            language: {
              label: "Sprache",
            },
          },
        },
      },
      adresses: {
        title: "Meine Adressen",
        info1:
          "Hier können Sie Adressdaten hinterlegen, die Sie später im Bestellprozess, z.B. für Ticketversand, als abweichende Versandanschrift einfügen können.",
        buttons: {
          addAdress: "Neue Adresse hinzufügen",
          manageAdresses: "Adressdaten verwalten",
        },
      },
      coOrderers: {
        title: "Meine Co-Besteller",
        info1:
          "Hier können Sie Co-Besteller hinterlegen, die Sie später im Bestellprozess, z.B. für Ticketversand, als abweichende Versandanschrift einfügen können.",
        buttons: {
          addCoOrderer: "Neuen Co-Besteller hinzufügen",
          manageCoOrderers: "Co-Besteller verwalten",
        },
      },
      company: {
        name: "Firmenname",
        street: "Straße",
        zip: "Postleitzahl",
        city: "Ort",
        country: "Land",
        email: "E-Mail",
        phone: "Telefon",
        language: "Sprache",
        tax: "USt-ID.Nr.",
      },
      form: {
        title: "Profil bearbeiten",
        saveButton: "Änderungen speichern",
        personals: {
          fields: {
            salutation: "Anrede",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail-Adresse",
            phone: "Telefonnummer",
            language: "Korrespondenzsprache",
            company: "Firma",
            country: "Land",
          },
        },
        unsavedChanges: "Ungespeicherte Änderungen",
      },
      complete: {
        title: "Profil vervollständigen",
        subtitle:
          "Vervollständigen Sie Ihr Profil, um die Anwendung nutzen zu können",
        saveButton: "Vervollständingen",
        personals: {
          title: "Persönliche Daten",
          fields: {
            salutation: "Anrede",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail-Adresse",
            phone: "Telefonnummer",
            language: "Korrespondenzsprache",
          },
        },
        company: {
          title: "Firma",
          fields: {
            company1: "Firmenname",
            companyStreet: "Straße",
            companyZipCode: "Postleitzahl",
            companyCity: "Ort",
            companyCountryCodeId: "Land",
          },
        },
        notifications: {
          success: "Profil erfolgreich vervollständigt!",
        },
      },
      incidents: {
        title: "Meine Anfragen",
        noData: "Derzeit liegen keine Serviceanfragen vor.",
        table: {
          name: {
            label: "Referenznummer",
          },
          type: {
            label: "Typ",
            items: {
              Claim: "Allgemeine Anfrage",
              Cancellation: "Stornierung",
              AuthorizationRequest: "Bestellautorisierung",
            },
          },
          status: {
            label: "Status",
            items: {
              Closed: "Genehmigt",
              Active: "In Bearbeitung",
              Cancelled: "Abgelehnt",
            },
          },
        },
        cards: {
          getSupport: {
            title: "Support erhalten",
            info: "Gern unterstützen wir Sie bei allen Fragen rund um Ihre Bestellungen im Store. Melden Sie sich gern unter: ",
            Phone: "Tel: 030-3038-1400",
            questionsAboutStore: "Fragen zum Store",
          },
          createRequest: {
            title: "Bestellautorisierung",
            buttons: {
              createIncident: "Anfrage erstellen",
            },
            info1:
              "Wenn Sie sich für Bestellungen im Store autorisieren lassen wollen, können Sie hier eine Anfrage erstellen.",
            info2:
              "Bitte beachten Sie, dass die Bearbeitung Ihrer Anfrage bis zu 3 Werktage in Anspruch nehmen kann.",
          },
        },
        createDialog: {
          title: "Supportanfrage erstellen",
          buttons: {
            createIncident: "Anfrage erstellen",
            cancel: "Abbrechen",
          },
          notifications: {
            success: "Die Anfrage wurde erfolgreich erstellt!",
            error: "Beim Erstellen der Anfrage ist ein Fehler aufgetreten",
          },
          infoFields: {
            productType: {
              label: "Produktbereich",
              options: {
                761330005: "Reguläre Nebenleistungen",
                761330007: "Ticketing",
                761330008: "Standbauleistungen",
              },
            },
            description: {
              label: "Beschreibung *",
              placeholder: "Beschreiben Sie ihr Anliegen...",
            },
          },
          cancellationFields: {
            bookingSelect: "Standbuchung",
            description: {
              label: "Beschreibung *",
              placeholder: "Beschreiben Sie ihr Anliegen...",
            },
            products: {
              title: "Produktauswahl",
              subtitle: "Welche Produkte sollen storniert werden?",
              senderName: "Besteller:",
            },
          },
          authorizationRequestFields: {
            companyName: "Firmenname",
            companyEmail: "E-Mail",
            companyCity: "Stadt",
            companyStreet: "Straße / Hausnummer",
            companyZipCode: "PLZ",
            companyCountryCodeId: "Land",
            companyPhone: "Telefon",
            language: "Sprache",
            clientLocation: "Unternehmenssitz",
            clientVatId: "Umsatzsteuer-Identifikationsnummer (USt-IdNr.)",
            description: {
              label: "Beschreibung",
              placeholder: "Beschreiben Sie ihr Anliegen...",
            },
            fileUpload: {
              description: "Ziehen Sie Ihre Datei per Drag & Drop hierher oder",
              button: "Laden Sie eine Datei hoch",
              maxFilesReached:
                "Sie haben die maximale Anzahl an Dateien erreicht",
              maxFileSizePerFile1: "Maximale Dateigröße: ",
              maxFileSizePerFile2: "MB",
              supportedFileType1: "Unterstütze Dateiformate: ",
              supportedFileType2: ".pdf, .jpg, .jpeg, .png",
              validation: {
                maxFileSize1:
                  "Die Dateigröße ist zu groß. Pro Datei sind maximal",
                maxFileSize2: "MB erlaubt.",
                fileType1:
                  "Dateityp ist nicht zulässig. Es sind nur Dateien vom Typ",
                fileType2: " erlaubt.",
                fileNameAlreadyExists:
                  "Eine Datei mit dem selben Namen wurde bereits hochgeladen.",
                tooManyFiles:
                  "Die Anzahl der hochgeladenen Dateien wird überschritten.",
              },
              error: "Beim Hochladen der Dateien ist ein Fehler aufgetreten",
            },
          },
        },
      },
    },
    account: {
      headline: "Konto",
      desc: "Sie sind mit den folgenden Angaben im Ausstellerportal der Messe Berlin registriert:",
      userInfo: {
        name: "Name",
        company: "Company",
        email: "E-Mail",
        phone: "Mobilnummer",
        noData: "Nicht definiert",
      },
      reset: {
        desc: "Sie können Ihr Passwort für den Zugang zum Ausstellerportal hier ändern.",
        button: "Passwort ändern",
      },
      support: {
        desc1: "Bitte schreiben Sie uns eine E-Mail an",
        desc2: ", wenn wir Ihre Daten anpassen sollen.",
        button: "Support per E-Mail kontaktieren",
      },
    },
    organization: {
      headline: "Standbuchungsdaten",
      description:
        "Hier finden Sie weitere Informationen zu Ihrer Firma, welche Sie vertreten.",
      form: {
        personals: {
          title: "Persönliche Daten",
          fields: {
            language: "Bitte wählen Sie die gewünschte Korrespondenzsprache:",
            title: "Titel",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail",
            position: "Position",
            department: "Abteilung",
            phone: "Telefon",
          },
        },
        company: {
          title: "Firmendaten Ihres Arbeitgebers",
          fields: {
            company1: "Firma",
            companyStreet: "Straße/Hausnummer",
            companyStreetNo: "Hausnr.",
            companyZipCode: "PLZ",
            companyZipCodeHelperText:
              "Für Länder oder Regionen ohne Postleitzahl, tragen Sie bitte die Ziffer Null ein.",
            companyCity: "Ort",
            companyRegion: "Region",
            companyCountryCodeId: "Land",
            companyWebsite: "Internet / Website",
            position: "Position",
            companyEmail: "E-Mail Firma allgemein",
            companyType: "Art des Betriebs",
          },
        },
      },
      uncomplete: "Unvollständig",
      button: "Speichern",
    },
    webshop: {
      headline: "Webshopdaten",
      form: {
        deliveryAddress: {
          title: "Lieferadresse",
          fields: {
            language: "Bitte wählen Sie die gewünschte Korrespondenzsprache:",
            companyName: "Firmenname",
            companyStreet: "Straße/Hausnummer",
            companyZipCode: "PLZ",
            companyZipCodeHelperText:
              "Für Länder oder Regionen ohne Postleitzahl, tragen Sie bitte die Ziffer Null ein.",
            companyCity: "Ort",
            companyCountryCodeId: "Land",
            companyCountryRegionCodeId: "Region",
            companyPhone: "Telefon",
            companyEmail: "E-Mail Firma allgemein",
          },
        },
        clientLocation: {
          title: "Nachweis der Unternehmereigenschaft",
          fields: {
            companyClientLocation: "Wir sind ein Unternehmen mit Sitz ...",
            companyClientLocationHelperText:
              "In der Regel unterliegen Waren und Dienstleistungen, die von einem Unternehmen in Deutschland erbracht werden, der deutschen Umsatzsteuer. Werden jedoch bestimmte Voraussetzungen erfüllt, kann die Messe Berlin GmbH sowie ihre Tochtergesellschaften Rechnungen ohne deutsche Umsatzsteuer erstellen. Für weitere Informationen wählen Sie bitte die zutreffende Option.",
            clientVatId: "Umsatzsteuer-Identifikationsnummer (USt-IdNr.)",
            clientVatIdHelperText:
              "Bitte beachten Sie, dass die angegebene USt-IdNr. von uns über MIAS (MwSt-Informationsaustauschsystem der Europäischen Union) geprüft werden muss. Stimmen die dort hinterlegten Daten nicht mit der angegebenen USt-IdNr. überein, ist die uns gemeldete USt-IdNr. nicht gültig.",
            clientVatIdDescription:
              "Wir sind ein Unternehmen mit Sitz innerhalb der Europäischen Union (§ 2 UStG bzw. Art. 9 der Richtlinie 2006/112 EG des Rates vom 28. November 2006 über das gemeinsame Mehrwertsteuersystem). Wir sind mit genannter Firmierung bei unserer zuständigen Steuerbehörde gemeldet. Für den Leistungsaustausch mit der Messe Berlin GmbH und ihren Tochtergesellschaften verwenden Sie bitte folgende Umsatzsteuer-Identifikations-Nummer (USt-ID.Nr). Wir bestätigen hiermit, dass die Leistungen, die unter der oben genannten USt-ID.Nr. eingekauft werden, im Rahmen unseres Unternehmens bezogen werden. Die vorgelegte USt-ID. Nr. soll bei allen Aufträgen an die Messe Berlin GmbH und ihren Tochtergesellschaften verwendet werden. Änderungen geben wir der Messe Berlin GmbH oder ihren Tochtergesellschaften rechtzeitig bekannt. Diese Einverständniserklärung kann jederzeit durch schriftliche Erklärung gegenüber der Messe Berlin GmbH, Abt. Finanzen, DE-14055 Berlin, widerrufen werden. Uns ist bewusst, dass die Messe Berlin GmbH und ihre Tochtergesellschaften bei fehlender Unternehmereigenschaft bzw. nicht nachgewiesener Unternehmereigenschaft die deutsche Umsatzsteuer von uns erheben wird.",
            businessCertificate:
              "Unternehmerbescheinigung & ggf. englische Übersetzung",
            businessCertificateHelperText:
              "Bitte beachten Sie, dass sich die Messe Berlin GmbH das Recht vorbehält, die vom Vertragspartner vorgelegten Nachweise abzulehnen, wenn diese nach Ansicht der Messe Berlin GmbH oder ihren Tochtergesellschaften nicht geeignet oder ausreichend erscheinen, um die Ansässigkeit und Unternehmereigenschaft des Vertragspartners hinreichend zu dokumentieren. Das Zertifikat und die Übersetzung können Sie als .pdf, .jpeg, .jpg, .png hochladen. Maximale Dateigröße ist 5 MB.",
            businessCertificateDescription:
              "Wir sind ein Unternehmen mit Sitz außerhalb der Europäischen Union. Wir sind mit oben genannter Firma als Unternehmen bei unserer zuständigen Steuerbehörde angemeldet. Für den Leistungsaustausch mit der Messe Berlin GmbH und ihren Tochtergesellschaften verwenden Sie bitte beiliegende Unternehmerbescheinigung unserer Steuerbehörde, welche die Ansässigkeit des Unternehmens außerhalb der Europäischen Union bestätigt.\r\n\r\n    Wir bestätigen hiermit, dass die Leistungen, die unter der beigefügten Unternehmerbescheinigung eingekauft werden, im Rahmen unseres Unternehmens bezogen werden. Die vorgelegte Unternehmerbescheinigung soll bei allen Aufträgen an die Messe Berlin GmbH und ihren Tochtergesellschaften verwendet werden. Änderungen geben wir der Messe Berlin GmbH oder ihren Tochtergesellschaften rechtzeitig bekannt. Diese Einverständniserklärung kann jederzeit durch schriftliche Erklärung gegenüber der Messe Berlin GmbH, Abt. Finanzen, DE-14055 Berlin, widerrufen werden. Uns ist bewusst, dass die Messe Berlin GmbH und ihre Tochtergesellschaften bei fehlender Unternehmereigenschaft bzw. nicht nachgewiesener Unternehmereigenschaft die deutsche Umsatzsteuer von uns erheben wird.",
          },
        },
      },
      button: "Bestellautorisierung anfragen",
      notAuthorized: "Optional",
      info: "Das Bestellen auf eigene Rechnung ist nur möglich, wenn Ihr Konto autorisiert wurde. Bitte füllen Sie das folgende Formular aus, wenn Sie auf Ihre eigene Rechnung im Webshop bestellen möchten.",
      webshopTextCompleted1: "Sie wurden für Bestellungen im ",
      webshopLink: "Webshop",
      webshopTextCompleted2: " freigeschalten.",
      webshopTextPending: "Ihr Antrag auf Autorisierung wird zur Zeit geprüft.",
      webshopTextCancelled:
        "Ihr Antrag auf Autorisierung wurde leider abgelehnt.",
    },
  },
}
